<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Distribuidor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div v-if="isDataLoaded" class="col-sm-6 col-xs-12 text-right">
          <router-link
            v-if="$can('store', 'documents')"
            :to="{
              name: 'DocumentUpload',
              params: { id: distributor.id, type: 'distributors' },
            }"
            class="btn base-button btn-neutral btn-sm mt-1"
          >
            Subir Archivos&nbsp;<i class="fas fa-upload"></i>
          </router-link>

          <router-link
            v-if="$can('index', 'documents')"
            :to="{
              name: 'DistributorDocuments',
              params: { id: distributor.id },
            }"
            class="btn base-button btn-neutral btn-sm mt-1"
          >
            Ver Archivos&nbsp;<i class="fas fa-copy"></i>
          </router-link>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row">
        <div class="col-sm-12">
          <distributor-data :collapsed="false" :distributor="distributor" />
        </div>
        <div class="col-sm-12">
          <producers-list :collapsed="true" :distributor="distributor.id" />
        </div>
      </div>

      <div v-if="$can('index', 'contacts')" class="row">
        <div class="col-md-12 col-sm-12">
          <contacts-list :entity-id="distributorId" :title="contactsTitle" entity="distributors">
            <template slot="title">
              <div class="row">
                <div class="col">
                  <h3 class="mb-0">Contactos</h3>
                </div>

                <div class="col text-right pr-5">
                  <router-link
                    v-if="$can('store', 'contacts')"
                    :to="{
                      name: 'DistributorCreateContact',
                      params: { id: distributorId },
                    }"
                    class="btn btn-outline-warning btn-sm"
                  >
                    <i class="fas fa-user"></i>&nbsp;Agregar Contactos
                  </router-link>
                </div>
              </div>
            </template>
          </contacts-list>
        </div>
      </div>

      <div v-if="$can('index', 'orders')" class="row">
        <div class="col-sm-12">
          <orders-table :collapse="true" :filter-distributor="distributor.id" title="Pedidos" />
        </div>
      </div>

      <div v-if="$can('index', 'projections')" class="row">
        <div class="col-md-12 col-sm-12">
          <projections-table :distributor="distributorId" :title="projectionsTitle"></projections-table>
        </div>
      </div>

      <div v-if="$can('index', 'visits')">
        <visits-table :custom-params="params" :show-author-filter="false" :title="visitsTitle">
          <template slot="actions">
            <router-link
              v-if="$can('store', 'visits')"
              :to="{ name: 'DistributorCreateVisit', params: { id: distributor.id } }"
              class="btn btn-outline-success btn-sm"
            >
              <i class="fas fa-calendar"></i>&nbsp;Nueva Visita
            </router-link>
          </template>
        </visits-table>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProducersList from '@/views/Distributors/Show/ProducersList';
import DistributorData from '@/views/Distributors/Show/DistributorData';
import VisitsTable from '@/views/Visits/List/VisitsTable';
import ContactsList from '@/views/Contacts/List/ContactsList';
import ProjectionsTable from '@/views/Projection/List/ProjectionsTable';
import OrdersTable from '../Orders/List/OrdersTable';
import ResetTableFilterMixin from '@/mixins/resetTableFilterMixin';

export default {
  name: 'DistributorsShow',
  components: {
    VisitsTable,
    ProducersList,
    DistributorData,
    ContactsList,
    ProjectionsTable,
    RouteBreadCrumb,
    OrdersTable,
  },

  mixins: [ResetTableFilterMixin],
  props: {
    documentableType: {
      type: String,
      default: 'distributors',
    },
  },

  data() {
    return {
      isDataLoaded: false,
      params: [],
      distributorId: null,
      distributor: null,
      visitsTitle: 'Visitas del distribuidor',
      contactsTitle: 'Contactos del distribuidor',
      projectionsTitle: 'Proyecciones del distribuidor',
    };
  },

  mounted() {
    this.distributorId = +this.$route.params.id;
    this.fetchDistributor();
    this.params.push({
      prop: 'filter[distributor]',
      value: this.distributorId,
    });
  },

  created() {
    this.mixSaveTableCurrentFilters('projection');
    this.mixSaveTableCurrentFilters('order');
    this.mixSaveTableCurrentFilters('visit');
  },

  beforeDestroy() {
    this.mixRetrieveTablePreviousFilters('projection');
    this.mixRetrieveTablePreviousFilters('order');
    this.mixRetrieveTablePreviousFilters('visit');
  },

  methods: {
    fetchDistributor() {
      const params = {
        append: ['plotscount'],
        include: ['city.province', 'seller', 'visitsCount', 'producersCount', 'documentsCount'],
      };

      this.$services
        .resource('distributors')
        .show(this.distributorId, params)
        .then((res) => res.data.data)
        .then((distributor) => {
          this.distributor = distributor;
          this.visitsTitle = `Visitas de ${distributor.name}`;
          this.contactsTitle = `Contactos de ${distributor.name}`;
          this.isDataLoaded = true;
        });
    },
  },
};
</script>
